import { QueryOptions, FetchPolicy } from 'apollo-client';
import * as query from './query.gql';

export const mainAccountQuery = (fetchPolicy: FetchPolicy = 'network-only'): QueryOptions<{}> => ({
  query,
  fetchPolicy,
});
